import React from 'react';
import { Fieldset } from '../fieldset';
import { FormField } from '../form-field';
import { FieldsetContent, RadioCheckboxGroupContainer, RadioCheckboxGroupItemsHorizontal, RadioCheckboxGroupItemsVertical, } from './styles';
export const RadioCheckboxGroup = ({ label, validationMessage, orientation = 'vertical', children, }) => {
    return (React.createElement(RadioCheckboxGroupContainer, null,
        React.createElement(Fieldset, null,
            React.createElement(FieldsetContent, null,
                label,
                orientation === 'vertical' ? (React.createElement(RadioCheckboxGroupItemsVertical, null, children)) : (React.createElement(RadioCheckboxGroupItemsHorizontal, null, children)))),
        validationMessage && (React.createElement(FormField.Error, { "aria-live": "assertive" }, validationMessage))));
};
//# sourceMappingURL=RadioCheckboxGroup.js.map